export default __webpack_public_path__ + "b86ede555ff154e78d11cd52202130ee.svg";